import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'reverseArray' })
export class FsReverseArrayPipe implements PipeTransform {
  constructor() {}

  public transform(array: any[]): any[] {
    return array.slice().reverse();
  }
}
